import { SharedConstants } from "../../../../../shared/constants/shared.constants";
export class ViewApplicationDetailsGtConstants {
    static STEP_TITLE = "Details";
    static DESCRIPTION_LABEL = "Description";
    static FILE_NUMBER_LABEL = "File number";
    static AMENDMENT_SCHEME_NUMBER_LABEL = "Amendment scheme number";
    static APPLICATION_TYPE_LABEL = "Application type";
    static ZONE_LABEL = "New property zone";
    static AMENDMENT_SCHEME_NUMBER_FORM_CONTROL_NAME = "amendmentSchemeNumber";
    static FILE_NUMBER_FORM_CONTROL_NAME = "fileNumber";
    static DESCRIPTION_FORM_CONTROL_NAME = "description";
    static APPLICATION_TYPES_FORM_CONTROL_NAME = "applicationTypes";
    static APPLICATION_TYPE_FORM_CONTROL_NAME = "type";
    static ZONES_FORM_CONTROL_NAME = "zones";
    static ZONE_FORM_CONTROL_NAME = "zone";
    static REFERENCE_NUMBER_CONTROL_NAME = "referenceNumber";
    static ADD_APPLICATION_TYPE_LABEL = "Add application type";
    static ADD_ZONE_LABEL = "Add zone";
    static REFERENCE_NUMBER_LABEL = "Reference number";
    static REZONING_APPLICATION_CONFIRMATION_CONTROL_NAME = "rezoneConfirmation";
    static REZONING_APPLICATION_CONFIRMATION_LABEL = "Is the application a rezoning application?";
    static REZONING_KEYWORD_REZONING = "rezoning";
    static REZONING_KEYWORD_REZONE = "rezone";
    static SAVE_BUTTON_PLACEHOLDER = SharedConstants.SAVE_LABEL;
    static VALIDATION_MESSAGES = {
        description: {
            required: `Description ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        applicationType: {
            required: `Application type ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        zone: {
            required: `Zone ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
    };
}
